// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file escorer/escorer.proto (package escorer, syntax proto3)
/* eslint-disable */

import { RPC } from "../runtime";

/**
 * @generated from message escorer.EscorerEventsRequest
 */
export type EscorerEventsRequest = {
/**
 * @generated from field: repeated string models = 1;
 */
models?: string[];
/**
 * @generated from field: repeated string score_modes = 2;
 */
scoreModes?: string[];
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 3;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 4;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 6;
 */
timezone?: string;
/**
 * @generated from field: escorer.UserContext user_context = 5;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message escorer.EscorerLatencyEventsResponse
 */
export type EscorerLatencyEventsResponse = {
/**
 * @generated from field: repeated escorer.LatencyData latencyData = 1;
 */
latencyData?: LatencyData[];
/**
 * @generated from field: repeated string available_models = 2;
 */
availableModels?: string[];
}
;
/**
 * @generated from message escorer.EscorerErrorEventsResponse
 */
export type EscorerErrorEventsResponse = {
/**
 * @generated from field: repeated escorer.ErrorData errorData = 1;
 */
errorData?: ErrorData[];
/**
 * @generated from field: repeated string available_models = 2;
 */
availableModels?: string[];
}
;
/**
 * @generated from message escorer.LatencyData
 */
export type LatencyData = {
/**
 * @generated from field: string ts = 1;
 */
ts?: string;
/**
 * @generated from field: string model_name = 2;
 */
modelName?: string;
/**
 * @generated from field: string score_mode = 3;
 */
scoreMode?: string;
/**
 * @generated from field: float datapoint_count = 4;
 */
datapointCount?: number;
/**
 * @generated from field: float average_latency = 5;
 */
averageLatency?: number;
}
;
/**
 * @generated from message escorer.ErrorData
 */
export type ErrorData = {
/**
 * @generated from field: string ts = 1;
 */
ts?: string;
/**
 * @generated from field: string model_name = 2;
 */
modelName?: string;
/**
 * @generated from field: string score_mode = 3;
 */
scoreMode?: string;
/**
 * @generated from field: float total_errors = 4;
 */
totalErrors?: number;
/**
 * @generated from field: string last_err_msg = 5;
 */
lastErrMsg?: string;
}
;
/**
 * @generated from message escorer.DailyEscorerLatencyCountsResponse
 */
export type DailyEscorerLatencyCountsResponse = {
/**
 * @generated from field: map<string, float> data = 1;
 */
data?: { [key: string]: number };
}
;
/**
 * @generated from message escorer.DailyEscorerErrorAndDatapointsCountsResponse
 */
export type DailyEscorerErrorAndDatapointsCountsResponse = {
/**
 * @generated from field: map<string, escorer.EScorerErrorAndDatapointCounts> data = 1;
 */
data?: { [key: string]: EScorerErrorAndDatapointCounts };
}
;
/**
 * @generated from message escorer.EScorerErrorAndDatapointCounts
 */
export type EScorerErrorAndDatapointCounts = {
/**
 * @generated from field: float total_errors = 1;
 */
totalErrors?: number;
/**
 * @generated from field: float datapoints = 2;
 */
datapoints?: number;
}
;
/**
 * @generated from message escorer.EScorerEvent
 */
export type EScorerEvent = {
/**
 * @generated from field: string hour = 1;
 */
hour?: string;
/**
 * @generated from field: string model_name = 2;
 */
modelName?: string;
/**
 * @generated from field: string score_mode = 3;
 */
scoreMode?: string;
/**
 * @generated from field: float average_datapoints = 4;
 */
averageDatapoints?: number;
/**
 * @generated from field: float average_latency = 5;
 */
averageLatency?: number;
/**
 * @generated from field: float average_total_errors = 6;
 */
averageTotalErrors?: number;
/**
 * @generated from field: string last_error_message = 7;
 */
lastErrorMessage?: string;
}
;
/**
 * @generated from message escorer.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc escorer.EscorerService.GetEscorerLatencyEvents
 */
export const EscorerService_GetEscorerLatencyEvents = new RPC<EscorerEventsRequest,EscorerLatencyEventsResponse>("POST", "/getEscorerLatency");
/**
 * @generated from rpc escorer.EscorerService.GetEscorerErrorEvents
 */
export const EscorerService_GetEscorerErrorEvents = new RPC<EscorerEventsRequest,EscorerErrorEventsResponse>("GET", "/getEscorerError");
/**
 * @generated from rpc escorer.EscorerService.GetDailyEscorerLatencyCounts
 */
export const EscorerService_GetDailyEscorerLatencyCounts = new RPC<EscorerEventsRequest,DailyEscorerLatencyCountsResponse>("GET", "/getDailyEscorerLatency");
/**
 * @generated from rpc escorer.EscorerService.GetDailyEscorerErrorAndDatapointsCounts
 */
export const EscorerService_GetDailyEscorerErrorAndDatapointsCounts = new RPC<EscorerEventsRequest,DailyEscorerErrorAndDatapointsCountsResponse>("GET", "/getDailyEscorerErrorAndDatapoints");
